import {
  ChangeDetectionStrategy, Component, EventEmitter,
  Input, Output,
  Type
} from '@angular/core';
import { AlertType } from '../../models';

@Component({
  selector: 'app-alert-custom',
  templateUrl: './alert-custom.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertCustomComponent {
  @Input()
  alertType: AlertType;

  @Input()
  displayCloseBtn = true;

  @Input()
  component?: Type<unknown>;

  @Input()
  componentInput?: Record<string, unknown>;

  @Output()
  closeClick = new EventEmitter<void>();
}
